import { PARTICIPANT_PROFILE_ERROR, PARTICIPANT_PROFILE_SUCCESS, PARTICIPANT_EDIT_PROFILE, PARTICIPANT_RESET_PROFILE_FLAG, PARTICIPANT_VIEW_PROFILE, PARTICIPANT_PASSWORD_CHANGE } from "./actionTypes";

const initialState = {
  error: "",
  success: "",
};

const profile = (state = initialState, action) => {
  switch (action.type) {
    case PARTICIPANT_VIEW_PROFILE:
      state = { ...state };
      break;
    case PARTICIPANT_EDIT_PROFILE:
      state = { ...state, loading: true, };
      break;
    case PARTICIPANT_PASSWORD_CHANGE:
      state = { ...state, loading: true, };
      break;
    case PARTICIPANT_PROFILE_SUCCESS:
      state = { ...state, success: action.payload, loading: false };
      break;
    case PARTICIPANT_PROFILE_ERROR:
      state = { ...state, error: action.payload, loading: false };
      break;
    case PARTICIPANT_RESET_PROFILE_FLAG:
      state = { ...state, success: null };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default profile;
